import {completeCustomerOfferCoefficientReview} from "@project/sdk/sales";
import {CompleteCustomerOfferCoefficientReviewResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../customerOffer-keys";

export function completeCustomerOfferCoefficientReviewMutationOptions() {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.completeCustomerOfferCoefficientReview,
    retry: false,
    mutationFn: async (id: string) =>
      CompleteCustomerOfferCoefficientReviewResponse.parse(
        await completeCustomerOfferCoefficientReview(id),
      ),
    onSuccess: async (_result, id, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: customerOfferKeys.detail(id)}),
        client.invalidateQueries({queryKey: customerOfferKeys.lists()}),
      ]);
    },
  });
}
